module.exports = __webpack_public_path__ + "img/bgProfessional QualificationCertificate.477c98d5.png";